module.exports = __webpack_public_path__ + "img/ALATTARH-LOGO.bf947545.png";